// extracted by mini-css-extract-plugin
export var logo = "Logo-module--logo--e4e7a";
export var logoCentered = "Logo-module--logoCentered--fc21e";